module.exports = require("react-share");


//////////////////
// WEBPACK FOOTER
// external "react-share"
// module id = 258
// module chunks = 0